<script setup lang="ts">
import { type DecorScreen, nullDecor } from "#ui/decoration/screen";

export interface Props {
	decor?: DecorScreen;
}

const props = withDefaults(defineProps<Props>(), { decor: () => nullDecor });

const FRONT_PATH =
	"M0,132 C80,132 120,30 240,30 C360,30 400,132 480,132 C560,132 600,30 720,30 C840,30 880,132 960,132 C1040,132 1080,30 1200,30 C1320,30 1360,132 1440,132 C1520,132 1560,30 1680,30 C1800,30 1840,132 1920,132 C2000,132 2040,30 2160,30 C2280,30 2320,132 2400,132 C2480,132 2520,30 2640,30 C2760,30 2800,132 2880,132 L2880,140 L0,140 Z";

const BACK_PATH =
	"M0,45 C120,45 160,140 240,140 C320,140 360,45 480,45 C600,45 640,140 720,140 C800,140 840,45 960,45 C1080,45 1120,140 1200,140 C1280,140 1320,45 1440,45 C1560,45 1600,140 1680,140 C1760,140 1800,45 1920,45 C2040,45 2080,140 2160,140 C2240,140 2280,45 2400,45 C2520,45 2560,140 2640,140 C2720,140 2760,45 2880,45 L2880,140 L0,140 Z";
</script>

<template>
	<div
		class="kso_waves tw:relative tw:w-full tw:h-(--kso-wave-height,45px) tw:overflow-hidden tw:flex-none tw:pointer-events-none"
		aria-hidden="true"
		v-bind="props.decor.bind('kso_waves')"
	>
		<div
			class="kso_waves_layer kso_waves_layer_back tw:absolute tw:left-0 tw:bottom-(--kso-wave-offset,-1px) tw:w-(--kso-wave-width,225%) tw:h-full tw:[filter:var(--kso-wave-back-filter,none)] tw:animate-[kso\_wave\_slide_var(--kso-wave-back-duration,16s)_linear_infinite_reverse]"
			v-bind="props.decor.bind('kso_wave_back')"
		>
			<svg
				v-if="props.decor.visible('kso_wave_paths')"
				class="tw:block tw:w-full tw:h-full"
				viewBox="0 0 2880 140"
				preserveAspectRatio="none"
				xmlns="http://www.w3.org/2000/svg"
				role="presentation"
			>
				<path class="tw:[fill:var(--kso-wave-back,var(--accentColorLight50,rgba(255,255,255,0.28)))]" :d="BACK_PATH" />
			</svg>
		</div>
		<div
			class="kso_waves_layer kso_waves_layer_front tw:absolute tw:left-0 tw:bottom-(--kso-wave-offset,-1px) tw:w-(--kso-wave-width,225%) tw:h-full tw:animate-[kso\_wave\_slide_var(--kso-wave-front-duration,9s)_linear_infinite]"
			v-bind="props.decor.bind('kso_wave_front')"
		>
			<svg
				v-if="props.decor.visible('kso_wave_paths')"
				class="tw:block tw:w-full tw:h-full"
				viewBox="0 0 2880 140"
				preserveAspectRatio="none"
				xmlns="http://www.w3.org/2000/svg"
				role="presentation"
			>
				<path
					class="tw:[fill:var(--kso-wave-front,var(--accentColor))] tw:[stroke:var(--kso-wave-stroke,none)] tw:[stroke-width:var(--kso-wave-stroke-width,0)] tw:[vector-effect:non-scaling-stroke]"
					:d="FRONT_PATH"
				/>
			</svg>
		</div>
	</div>
</template>

<style lang="scss">
  @use './ksoWaves.scss';
</style>
